import type {TGamePlayer} from '@kapitalist/contract/types'
import ExposedGamePlayer from '~/models/game/GamePlayers/ExposedGamePlayer'
import type ExposedHand from '~/models/game/Hands/ExposedHand'
import type Portfolio from '~/models/game/Portfolio'

/**
 * the logged-in, playing-via-this-instance-of-the-client player playing in the
 * current game ("you").
 *
 * NB: In practice, this will overlap with `AuthenticatedPlayer`, (same `playerId`,
 * username, etc) since that's also "the current person using the web client",
 * but this class is solely used during/for gameplay.
 */
export default class CurrentGamePlayer extends ExposedGamePlayer {
  constructor(playerData: TGamePlayer, portfolio: Portfolio, hand: ExposedHand) {
    super(playerData, portfolio, hand)
  }
}
